import { defineComponent as _defineComponent } from 'vue'
import { Item } from '../../types';
import ModalImportListItem from './ModalImportListItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportList',
  props: {
    isLoading: { type: Boolean },
    items: { default: () => [] }
  },
  emits: ["item-selected"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'item-selected', value: Item): void;
}), expose: any, slots: any, attrs: any }) {





const itemSelected = (item: Item) => {
    emit('item-selected', item);
};

return { __sfc: true,emit, itemSelected, ModalImportListItem }
}

})